export { default as Footer } from './Footer'
export { default as footerFactory } from './FooterFactory'
export type { FooterColumnsProps, FooterProps } from './Footer'
